/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 使用者情報
 */
export interface Szoa206aResponseElecAceptSearchResultDtoUserInfo {
    /**
     * 使用者需要者区分：英数字<br>　コード変換マスターテーブル.画面項目ID「C401050」のユーザコードを設定
     */
    userCnsdiv?: string;
    /**
     * 使用者需要者区分名称：全半角混在
     */
    userCnsdivAname?: string;
    /**
     * 使用者お客さま漢字氏名：全角
     */
    userName?: string;
    /**
     * 使用者お客さまカナ氏名：全角（カナ/数字/英字/スペース/記号）
     */
    userKanaName?: string;
    /**
     * 使用者お客さま電話番号コード１：英数字<br>　コード変換マスターテーブル.画面項目ID「C000010」のユーザコードを設定
     */
    userTeldv1?: string;
    /**
     * 使用者お客さま電話番号コード１名称：全半角混在
     */
    userTeldv1Aname?: string;
    /**
     * 使用者お客さま電話番号１：半角
     */
    userTelNo1?: string;
    /**
     * 使用者お客さま電話番号コード２：英数字<br>　コード変換マスターテーブル.画面項目ID「C000010」のユーザコードを設定
     */
    userTeldv2?: string;
    /**
     * 使用者お客さま電話番号コード２名称：全半角混在
     */
    userTeldv2Aname?: string;
    /**
     * 使用者お客さま電話番号２：半角
     */
    userTelNo2?: string;
    /**
     * 使用者お客さま電話番号コード３：英数字<br>　コード変換マスターテーブル.画面項目ID「C000010」のユーザコードを設定
     */
    userTeldv3?: string;
    /**
     * 使用者お客さま電話番号コード３名称：全半角混在
     */
    userTeldv3Aname?: string;
    /**
     * 使用者お客さま電話番号３：半角
     */
    userTelNo3?: string;
    /**
     * 使用者お客さまＦＡＸ番号：半角
     */
    userFaxNo?: string;
    /**
     * 使用者お客さまメールアドレス：半角
     */
    userMaddr?: string;
}

